import React, { useState } from 'react';
import { Bell } from 'lucide-react';
import NotificationDropdown from './NotificationDropdown';
import './NotificationBell.css';

const NotificationBell = ({ notifications, unreadCount, onMarkAsRead, onMarkAllAsRead, onClear }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleBellClick = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleDropdownClose = () => {
    setIsDropdownOpen(false);
  };

  return (
    <div className="notification-bell-container">
      <div className="notification-bell-wrapper">
        <button
          className="notification-bell-btn"
          onClick={handleBellClick}
          title={unreadCount > 0 ? `${unreadCount} unread notifications` : 'No notifications'}
          aria-label="Notifications"
        >
          <Bell size={20} />
          {unreadCount > 0 && (
            <span className="notification-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
          )}
        </button>

        {isDropdownOpen && (
          <NotificationDropdown
            notifications={notifications}
            onClose={handleDropdownClose}
            onMarkAsRead={onMarkAsRead}
            onMarkAllAsRead={onMarkAllAsRead}
            onClear={onClear}
          />
        )}
      </div>
    </div>
  );
};

export default NotificationBell;
